// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"a5662604","732":"386c98ac","977":"04241ff1"}[chunkId] + ".chunk.js";
};